import { OptionType } from 'components';

export enum TypeDeclaration {
    Choice1 = 'RC',
    Choice2 = 'RCSS',
}

export const optionTypeDeclaration: OptionType[] = [
    { value: TypeDeclaration.Choice1, label: 'Choix 1 - Envoyer l’arrêt de travail à SG santé uniquement' },
    { value: TypeDeclaration.Choice2, label: 'Choix 2 - Envoyer l’arrêt de travail à la Sécurité Sociale & à SG santé (EDI Machine)' },
];
